import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'changePwSection' ];
  declare readonly changePwSectionTarget: HTMLElement;

  connect() {
  }

  toggleChangePw = e => {
    const visible = e.currentTarget.value;
    if (visible === 'true') {
      this.changePwSectionTarget.classList.remove('hidden');
      this.changePwSectionTarget.querySelector('input').focus();
    }
    else {
      this.changePwSectionTarget.classList.add('hidden');
      this.changePwSectionTarget.querySelectorAll('input').forEach(input => {
        input.value = '';
      });
    }
  }
}
